/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AdminConfigTypeDelete = {
  id: 'admin-article.delete',
  tag: 'Admin',
  summary: 'Delete admin article',
  description: 'Delete a help article',
  method: 'delete',
  flags: { isAuthorized: true },
  route: () => `/administration/config/jira`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
